export default __webpack_public_path__ + "static/media/tick.d430c22e.svg";